<template>
    <div class="greybox" style="height: 500px;padding: 70px">
        <div class="row">
            <div class="col text-center">
                <i class="fas fa-exclamation-triangle text-danger" style="font-size: 8rem;"></i>
            </div>            
        </div>
        <div class="row mt-5">
            <div class="col text-center">                
                <p>There was a problem submitting your claim.</p>  
                <p>Please try again later or call the Claims Team on <a v-bind:href="'tel:' + resellerInfo.telephone">{{resellerInfo.telephone}}</a></p>
                <router-link tag="button" class="button" to="/">Home</router-link>
            </div>
        </div>    
    </div>
</template>
    
<script>
import { mapGetters } from 'vuex'
export default {
    computed: {
        ...mapGetters({
            resellerInfo: 'reseller/getResellerInfo'
        })
    }
}
</script>

